import { SegmentView } from "@tiny/api";
import { formatFromUtc } from "@tiny/components/src/utils/dateUtils";

const DATE_FORMAT = "d MMM, yy - h:mm aa";

export function getSegmentDateBySort(item: SegmentView, sort: string[]) {
  const sortedCreated = sort[0].includes("createdAt");
  const date = sortedCreated ? item.createdAt : item.updatedAt;
  const prefix = sortedCreated ? "Created at" : "Updated at";
  const formated = formatFromUtc(new Date(date!), DATE_FORMAT);
  return `${prefix} ${formated}`;
}
